import {range, zerofill} from "../utils/functions";

const BACKGROUND_BASE_PATH = '/images/background/';

export const BackgroundImages = range(1, 52).map(
    i => {
        const key = zerofill(i.toString(), 3);
        return {
            key,
            src: BACKGROUND_BASE_PATH + `${key}.jpg`,
            thumbnail: BACKGROUND_BASE_PATH + `${key}-thumbnail.jpg`
        }
    }
);

export function BackgroundKey2Src(key: string) {
    const src = BackgroundImages.find(b => b.key === key);
    if (src === undefined) {
        throw new Error("no background key");
    }
    return src.src;
}
